import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableFooter from '@mui/material/TableFooter'
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import './applicationTableEmploymentInfo.scss' 


const  ApplicationTableEducationInfo = ({ applicationData}) => {

  return (
            
    <div className='item'>

        <div className="details">

              
            <div className='detailItem'>
                <span className='itemKey'>Education:</span>
                <span className='itemValue'>{applicationData.education}</span>
            </div>
            <div className='detailItem'>
                <span className='itemKey'>School Attended:</span>
                <span className='itemValue'>{applicationData.schoolAttended}</span>
            </div>
            <div className='detailItem'>
                <span className='itemKey'>Date Of Admission:</span>
                <span className='itemValue'>{applicationData.dateOfAdmission}</span>
            </div>

            <div className='detailItem'>
                <span className='itemKey'>Date of Graduation:</span>
                <span className='itemValue'>{applicationData.dateOfGraduation}</span>
            </div>
            <div className='detailItem'>
                <span className='itemKey'>Course Studied:</span>
                <span className='itemValue'>{applicationData.course}</span>
            </div>
            <div className='detailItem'>
                <span className='itemKey'>School Address:</span>
                <span className='itemValue'>{applicationData.schoolAddress}</span>
            </div>
        
        </div>
    </div>
   
  );
}

export default ApplicationTableEducationInfo